(() => {
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  function init(builder) {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';

    const form = builder.closest('form[action*="/cart/add"]');
    if (!form) return;
    const groups = [...builder.querySelectorAll('[data-salve-group]')];
    const packagingGroups = [...builder.querySelectorAll('[data-salve-packaging]')];
    const error = builder.querySelector('[data-salve-error]');

    const selectedValues = (group) => [...group.querySelectorAll('input[type="checkbox"]:checked')].map((input) => input.value);
    const jarCount = () => {
      const productInfo = builder.closest('[id^="ProductInfo-"]');
      const selected = productInfo?.querySelector('variant-selects input[type="radio"]:checked, variant-selects select option:checked');
      const source = selected?.textContent || selected?.value || '';
      if (/sample/i.test(source)) return 1;
      const match = source.match(/[\d,]+/);
      return match ? Number(match[0].replace(/,/g, '')) : 1;
    };
    const orderQuantity = () => Number(document.querySelector(`[form="${CSS.escape(form.id)}"][name="quantity"]`)?.value || form.querySelector('[name="quantity"]')?.value || 1);

    function update() {
      let total = 0;
      let feePerJarCents = 0;
      groups.forEach((group) => {
        const values = selectedValues(group);
        const max = Number(group.dataset.max);
        total += values.length;
        const groupRates = {
          Herbs: Number(builder.dataset.herbCents),
          Scents: Number(builder.dataset.scentCents),
          Actives: Number(builder.dataset.activeCents)
        };
        feePerJarCents += values.length * groupRates[group.dataset.salveGroup];
        group.querySelector('[data-salve-group-count]').textContent = `${values.length} selected`;
        group.querySelector('[data-salve-group-message]').textContent = values.length >= max ? `Maximum of ${max} selected` : '';
        group.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach((input) => { input.disabled = values.length >= max; });
        const none = group.querySelector('[data-salve-none]');
        if (none) none.classList.toggle('is-selected', values.length === 0);
        const property = form.querySelector(`[data-salve-property="${group.dataset.salveGroup}"]`);
        if (property) property.value = values.length ? values.join(', ') : 'None';
      });
      packagingGroups.forEach((group) => {
        const selected = group.querySelector('input[type="radio"]:checked');
        if (!selected) return;
        feePerJarCents += Number(selected.dataset.feeCents || 0);
        const property = form.querySelector(`[data-salve-property="${group.dataset.salvePackaging}"]`);
        if (property) property.value = selected.value;
      });
      builder.querySelector('[data-salve-count]').textContent = `${total} ingredient${total === 1 ? '' : 's'}`;
      builder.querySelector('[data-salve-price]').textContent = money(feePerJarCents * jarCount() * orderQuantity());
      error.hidden = true;
      return { total, feePerJarCents };
    }

    groups.forEach((group) => {
      group.addEventListener('change', update);
      group.querySelector('[data-salve-search]').addEventListener('input', (event) => {
        const term = event.target.value.trim().toLowerCase();
        group.querySelectorAll('[data-salve-option]').forEach((option) => { option.hidden = !option.dataset.search.includes(term); });
      });
      group.querySelector('[data-salve-none]')?.addEventListener('click', () => {
        group.querySelectorAll('input:checked').forEach((input) => { input.checked = false; });
        update();
      });
    });
    packagingGroups.forEach((group) => group.addEventListener('change', update));
    document.addEventListener('change', (event) => {
      if (event.target.matches('variant-selects select, variant-selects input, [name="quantity"]')) update();
    });

    form.addEventListener('submit', async (event) => {
      const herbGroup = builder.querySelector('[data-salve-group="Herbs"]');
      if (selectedValues(herbGroup).length < Number(herbGroup.dataset.min)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.textContent = 'Please choose at least one herb or flower.';
        error.hidden = false;
        herbGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const feeVariantId = Number(builder.dataset.feeVariantId);
      if (!feeVariantId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        error.textContent = 'Customization checkout is being configured. Please try again shortly.';
        error.hidden = false;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('[type="submit"]');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');

      const values = Object.fromEntries(new FormData(form));
      const selection = update();
      const mainQuantity = orderQuantity();
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      });
      const bundleId = window.crypto?.randomUUID?.() || `salve-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      properties._custom_salve_bundle = bundleId;
      const feeUnitCents = Number(builder.dataset.feeUnitCents);
      const feeQuantity = (selection.feePerJarCents / feeUnitCents) * jarCount() * mainQuantity;
      const request = {
        items: [
          { id: Number(values.id), quantity: mainQuantity, properties },
          { id: feeVariantId, quantity: feeQuantity, properties: { _custom_salve_parent: String(values.id), _custom_salve_bundle: bundleId, _ingredient_count: String(selection.total) } }
        ],
        sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text',
        sections_url: window.location.pathname
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(request)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this formula to the cart.');
        window.location = window.routes.cart_url;
      } catch (exception) {
        error.textContent = exception.message;
        error.hidden = false;
      } finally {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    }, true);

    update();
  }

  const boot = () => document.querySelectorAll('[data-salve-builder]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
